<p-dialog
  [visible]="isVisible()"
  (visibleChange)="!$event && cancelCrop()"
  header="Crop Image"
  [modal]="true"
  [closeOnEscape]="true"
  [closable]="true"
  (onHide)="cancelCrop()"
  styleClass="crop-dialog"
  aria-labelledby="crop-dialog-title">

  <div class="p-fluid">
    @if (imageBase64) {
      <image-cropper
        [imageBase64]="imageBase64"
        [maintainAspectRatio]="true"
        [aspectRatio]="1"
        [resizeToWidth]="128"
        [cropperMinWidth]="90"
        [cropperMinHeight]="90"
        format="png"
        output="base64"
        (imageCropped)="onImageCropped($event)"
        (imageLoaded)="onCropperReady()">
      </image-cropper>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex gap-2 justify-content-end">
      <app-button label="Cancel" type="button" variant="outline" color="secondary" size="sm" [fullWidth]="false"
        (clicked)="cancelCrop()">
      </app-button>
      <app-button label="Confirm" type="button" variant="filled" color="primary" size="sm" [fullWidth]="false"
        (clicked)="confirmCrop()">
      </app-button>
    </div>
  </ng-template>
</p-dialog>
